import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import { EditableText, EditableImage, EditableSection, useAdmin } from './AdminContentEditor';

// Logo
const logoImage = 'https://customer-assets.emergentagent.com/job_calmcuriosity/artifacts/69bddqi7_2.png';

export const Footer = () => {
  const { theme } = useTheme();
  const { isEditMode } = useAdmin();
  
  const links = [
    { label: 'resources', href: '/#resources' },
    { label: 'events', href: '/#events' },
  ];
  
  const handleNavClick = (href) => {
    if (href.startsWith('/#')) {
      const element = document.querySelector(href.replace('/', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const content = (
    <footer 
      className="py-12 md:py-20 pb-24 md:pb-20 px-4 md:px-6 relative" 
      role="contentinfo"
      style={{
        background: 'linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.85) 100%)',
      }}
    >
      {/* Blur overlay for better readability */}
      <div className="absolute inset-0 backdrop-blur-sm" aria-hidden="true" />
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="flex flex-col items-center gap-6 md:gap-10">
          {/* Large Logo - much bigger */}
          <EditableImage
            sectionId="footer"
            field="logo"
            defaultSrc={logoImage}
            alt="Data Dreaming - Home"
            className="h-16 md:h-24 lg:h-32"
            style={{ filter: 'brightness(0) invert(1)' }}
          />
          
          {/* Navigation */}
          <nav className="flex flex-wrap justify-center gap-4 md:gap-8" aria-label="Footer navigation">
            {links.map((link) => (
              <button
                key={link.label}
                onClick={() => handleNavClick(link.href)}
                className="text-xs md:text-sm text-white/60 hover:text-white transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-white/50 rounded px-1"
              >
                {link.label}
              </button>
            ))}
          </nav>
        </div>
        
        {/* Divider */}
        <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-white/10 flex flex-col items-center gap-4 md:gap-6">
          {/* Copyright */}
          <p className="text-xs md:text-sm text-white/40">
            © {new Date().getFullYear()}
          </p>
          
          {/* Made with coffee & strawberries */}
          <p className="text-sm md:text-base text-white/50">
            <EditableText
              sectionId="footer"
              field="tagline"
              defaultValue="made with ☕️ & 🍓"
              className="text-sm md:text-base text-white/50"
            />
          </p>
        </div>
      </div>
    </footer>
  );

  if (isEditMode) {
    return <EditableSection sectionId="footer">{content}</EditableSection>;
  }

  return content;
};

export default Footer;
